// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RevisionSection_container__bZKUc {
  text-align: right;
}

.RevisionSection_clickable__lClh3 {
  cursor: pointer;
}


.RevisionSection_title__VbU5V {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
}

.RevisionSection_addSuppliers__iwN36 {
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}

.RevisionSection_filter__mid1D {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 1rem 0;
}


.RevisionSection_input__HnK06 {
  text-align: left;
  width: 20%;
  padding: 10px;
  margin-right: 1%;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;
  overflow: hidden;
}

.RevisionSection_filters__select__tsisd {
  width: 21%;
  margin-right: 1%;
}


.RevisionSection_tableWrapper__A3HiJ {
  margin-top: 20px;
  max-height: 26vw;
  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative; /* на всякий случай */
}

/* убери overflow:hidden у самой таблицы, иначе может клипать */
.RevisionSection_table__uW03i {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  /* overflow: hidden;  <-- убираем */
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* фиксируем шапку внутри scroll-контейнера */
.RevisionSection_table__uW03i thead th {
  position: sticky;
  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */
  z-index: 5;
  background-color: #f9f9f9;
}

.RevisionSection_page__ihcH2 {
  color: red;
}
.RevisionSection_table__uW03i th,
.RevisionSection_table__uW03i td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.RevisionSection_table__uW03i th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.RevisionSection_table__uW03i tr:hover {
  background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tablesStyle/RevisionSection.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM,EAAE,2DAA2D;EACnE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  text-align: right;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.addSuppliers {\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n.filter {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n\n.input {\n  text-align: left;\n  width: 20%;\n  padding: 10px;\n  margin-right: 1%;\n  font-size: 14px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;\n  overflow: hidden;\n}\n\n.filters__select {\n  width: 21%;\n  margin-right: 1%;\n}\n\n\n.tableWrapper {\n  margin-top: 20px;\n  max-height: 26vw;\n  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative; /* на всякий случай */\n}\n\n/* убери overflow:hidden у самой таблицы, иначе может клипать */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  /* overflow: hidden;  <-- убираем */\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* фиксируем шапку внутри scroll-контейнера */\n.table thead th {\n  position: sticky;\n  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RevisionSection_container__bZKUc`,
	"clickable": `RevisionSection_clickable__lClh3`,
	"title": `RevisionSection_title__VbU5V`,
	"addSuppliers": `RevisionSection_addSuppliers__iwN36`,
	"filter": `RevisionSection_filter__mid1D`,
	"input": `RevisionSection_input__HnK06`,
	"filters__select": `RevisionSection_filters__select__tsisd`,
	"tableWrapper": `RevisionSection_tableWrapper__A3HiJ`,
	"table": `RevisionSection_table__uW03i`,
	"page": `RevisionSection_page__ihcH2`
};
export default ___CSS_LOADER_EXPORT___;
